import React, { useEffect, useState } from "react";
import {
  ChatBubbleLeftRightIcon,
  ChevronDownIcon,
  GlobeAsiaAustraliaIcon,
  HomeIcon,
  PencilSquareIcon,
  ShoppingBagIcon,
} from "@heroicons/react/24/outline";
import SelectLang from "./SelectLang";
import {
  Navbar,
  NavbarBrand,
  NavbarMenuToggle,
  NavbarContent,
  NavbarItem,
  NavbarMenu,
  NavbarMenuItem,
  Button,
} from "@nextui-org/react";
import { Link, Link as RouterLink, useNavigate } from "react-router-dom"; // Import React Router Link
import { useApi } from "../Context/ApiProvider";
import { useTranslation } from "react-i18next";

export default function Header() {
  const api = useApi();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isDropdownVisible, setDropdownVisible] = useState(false); // State for dropdown
  const [isDropdownVisibleContact, setDropdownVisibleContact] = useState(false); // State for dropdown
  const [hoverTimeoutId, setHoverTimeoutId] = useState(null); // To store timeout ID
  const [isScrolled] = useState(false);

  useEffect(() => {
    (async () => {
      const resCategories = await api.uget("/api/shop/categories?");
      if (resCategories.ok && resCategories.body?.results) {
        const fetchedCategories = resCategories.body.results.map(
          (category) => ({
            id: category.id,
            title: category.title,
            description: category.description,
            image: category.image ? category.image.url : null,
          })
        );
        setCategories(fetchedCategories);
      }
    })();
  }, [api]);

  const handleMouseEnter = () => {
    clearTimeout(hoverTimeoutId);
    setDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    const timeoutId = setTimeout(() => {
      setDropdownVisible(false);
    }, 70);
    setHoverTimeoutId(timeoutId);
  };

  const handleMouseEnterContact = () => {
    clearTimeout(hoverTimeoutId);
    setDropdownVisibleContact(true);
  };

  const handleMouseLeaveContact = () => {
    const timeoutId = setTimeout(() => {
      setDropdownVisibleContact(false);
    }, 70);
    setHoverTimeoutId(timeoutId);
  };

  const menuItems = [
    {
      id: 3,
      name: t("menuBlog"),
      route: "/blog",
      icon: <PencilSquareIcon className="w-8 h-8 pl-2 -mt-1" />,
    },

    {
      id: 5,
      name: t("menuaboutUs"),
      route: "/about",
      icon: <GlobeAsiaAustraliaIcon className="w-8 h-8 -mt-1 pl-2" />,
    },
  ];

  const menuContact = [
    {
      id: 1,
      name: t("CentralOffice"),
      route: `/${localStorage.getItem("lng")}/contact/head-office`,
    },
    {
      id: 2,
      name: t("factory"),
      route: `/${localStorage.getItem("lng")}/contact/factory/`,
    },
  ];

  const mobileMenuItems = [
    {
      id: 1,
      name: t("menuHome"),
      route: "/",
      icon: <HomeIcon className="w-8 h-8 -mt-1 pl-2" />,
    },
    {
      id: 2,
      name: t("menuproducts"),
      route: "/products",
      icon: <ShoppingBagIcon className="w-8 h-8 -mt-1 pl-2" />,
    },
    {
      id: 3,
      name: t("menuBlog"),
      route: "/blog",
      icon: <PencilSquareIcon className="w-8 h-8 pl-2 -mt-1" />,
    },

    {
      id: 5,
      name: t("menuaboutUs"),
      route: "/about",
      icon: <GlobeAsiaAustraliaIcon className="w-8 h-8 -mt-1 pl-2" />,
    },
  ];
  return (
    <Navbar
      className={`xl:shadow-2xl  bg-white  xl:p-2 absolute xl:fixed xl:top-0   m-auto !px-0 xl:px-3 transition-all duration-300 ${
        isScrolled ? " !w-full  shadow-2xl  rounded-none " : "bg-white"
      }`}
      onMenuOpenChange={setIsMenuOpen}
      maxWidth="full"
    >
      <div className="flex items-center xl:gap-20 ">
        <NavbarMenuToggle
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          className="xl:hidden absolute z-50 "
        />
        <NavbarBrand
          as={RouterLink}
          to={"/"}
          className={`flex items-center gap-1 xl:gap-2 justify-end md:justify-start hover:text-primary  xl:mr-0 ${
            localStorage.getItem("lng") === "fa"
              ? " mr-7"
              : localStorage.getItem("lng") === "en"
              ? " ml-9"
              : ""
          }`}
        >
          <img src="/Assets/Images/fidar.png" alt="" className=" h-10 " />
          <p className="font-bold text-sm xl:text-base ">{t("menuTitle")}</p>
        </NavbarBrand>
        <NavbarContent
          className="hidden xl:flex  font-semibold"
          justify="center"
        >
          <NavbarItem className="ml-[1.5%]">
            <RouterLink
              to={"/"}
              className="text-gray-800 flex flex-row font-YekanBakhMedium hover:text-primary"
            >
              <HomeIcon className="w-8 h-8 -mt-1 pl-2" />
              <span className="pt-1">{t("menuHome")}</span>
            </RouterLink>
          </NavbarItem>
          <NavbarItem>
            <div
              className="relative group"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <RouterLink
                className="flex flex-row items-center text-gray-800 font-YekanBakhMedium hover:text-primary"
                to={`/products`}
              >
                <ShoppingBagIcon className="w-8 h-8 -mt-1 pl-2 " />
                <span className="pt-1">{t("menuproducts")}</span>
                <ChevronDownIcon className="w-4 h-4 animate-pulse mr-1 ml-1" />
              </RouterLink>
              <div
                className={`dropdown-content absolute bg-white shadow-xl rounded mt-5 transition-opacity duration-300 ${
                  isDropdownVisible
                    ? "opacity-100"
                    : "opacity-0 pointer-events-none"
                }`}
              >
                {categories.map((category) => (
                  <RouterLink
                    key={category.id}
                    to={`/${localStorage.getItem("lng")}/products/?category=${
                      category.id
                    }`}
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200 hover:text-primary"
                  >
                    {category.title}
                  </RouterLink>
                ))}
              </div>
            </div>
          </NavbarItem>

          <div className="flex items-center gap-5">
            {menuItems.map((item) => (
              <NavbarItem key={item.id} className="">
                <RouterLink
                  to={item.route}
                  className="text-gray-800  flex flex-row font-YekanBakhMedium hover:text-primary"
                >
                  {item.icon}
                  <span className="pt-1">{item.name}</span>
                </RouterLink>
              </NavbarItem>
            ))}
          </div>
          <NavbarItem>
            <div
              className="relative "
              onMouseEnter={handleMouseEnterContact}
              onMouseLeave={handleMouseLeaveContact}
            >
              <RouterLink
                className="flex flex-row items-center text-gray-800 font-YekanBakhMedium hover:text-primary"
                to={`/contact`}
              >
                <ChatBubbleLeftRightIcon className="w-8 h-8 -mt-1 pl-2" />
                <span className="pt-1">{t("menucontactUs")}</span>
                <ChevronDownIcon className="w-4 h-4 animate-pulse  mr-1 ml-1" />
              </RouterLink>
              <div
                className={`dropdown-content absolute bg-white shadow-xl rounded mt-5 transition-opacity duration-300 w-[15rem] ${
                  isDropdownVisibleContact
                    ? "opacity-100"
                    : "opacity-0 pointer-events-none"
                }`}
              >
                {menuContact.map((contact) => (
                  <RouterLink
                    key={contact.id}
                    to={contact.route}
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200 hover:text-primary"
                  >
                    {contact.name}
                  </RouterLink>
                ))}
              </div>
            </div>
          </NavbarItem>
        </NavbarContent>
        <NavbarContent justify="end" className="hidden xl:flex"></NavbarContent>

        <NavbarMenu className="bg-black bg-opacity-85 blur-none  backdrop-blur-none ">
          <div className="mt-4 ">
            <div className="flex  items-center gap-3">
              <Button
                onClick={() => navigate("/products")}
                radius="md"
                variant="solid"
                className="bg-blue-500 text-white w-20 lg:w-36 sm:w-full      "
              >
                <span className="font-bold lg:text-xl">{t("menucatalog")}</span>
              </Button>
              <Button
                onClick={() => navigate("/contact")}
                className="bg-gray-800 text-white w-20 lg:w-36 sm:w-full  "
                variant="solid"
                radius="md"
              >
                <span className="font-bold  lg:text-xl">
                  {t("menuconsultation")}
                </span>
              </Button>
            </div>
            {mobileMenuItems.map((item) => (
              <NavbarMenuItem key={item.id} className="flex items-center">
                <Link className="text-white mt-6 flex flex-row" to={item.route}>
                  {item.icon}
                  <span className="pt-1 pl-2  ">{item.name}</span>
                </Link>
                {item.id === 2 && (
                  <div
                    className="relative group top-3 "
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <button className="flex flex-row items-center text-white font-YekanBakhMedium hover:text-primary">
                      <ChevronDownIcon className="w-4 h-4 " />
                    </button>
                    <div
                      className={`dropdown-content absolute bg-white shadow-xl rounded w-[32vh] transition-opacity duration-300 ${
                        isDropdownVisible
                          ? "opacity-100"
                          : "opacity-0 pointer-events-none"
                      }`}
                    >
                      {categories.map((category) => (
                        <Link
                          key={category.id}
                          to={`/${localStorage.getItem(
                            "lng"
                          )}/products/?category=${category.id}`}
                          className="block px-4 py-2 text-gray-800 hover:bg-gray-200 text-sm "
                        >
                          {category.title}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </NavbarMenuItem>
            ))}
            <NavbarMenuItem>
              <div
                className="relative "
                onMouseEnter={handleMouseEnterContact}
                onMouseLeave={handleMouseLeaveContact}
              >
                <button className="text-white mt-6 flex flex-row items-center   ">
                  <ChatBubbleLeftRightIcon className="w-8 h-8 -mt-1 pl-2" />
                  <Link className="pt-1 ml-2" to={"/contact"}>
                    {t("menucontactUs")}
                  </Link>
                  <ChevronDownIcon className="w-4 h-4 animate-pulse " />
                </button>
                <div
                  className={`dropdown-content absolute bg-white shadow-xl rounded mt-5 transition-opacity duration-300 w-[10rem] ${
                    isDropdownVisibleContact
                      ? "opacity-100"
                      : "opacity-0 pointer-events-none"
                  }`}
                >
                  {menuContact.map((contact) => (
                    <Link
                      key={contact.id}
                      to={contact.route}
                      className="block px-4 py-2 text-gray-800 hover:bg-gray-200 hover:text-primary"
                    >
                      {contact.name}
                    </Link>
                  ))}
                </div>
              </div>
            </NavbarMenuItem>
          </div>
        </NavbarMenu>
      </div>

      <SelectLang isHeader={true} />
    </Navbar>
  );
}
